module.exports = __webpack_public_path__ + "static/media/pubblicazioni.86098a7a.svg";